<template>

  <router-view/>

</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style>
  .clickable{
    cursor:pointer;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
  .cadastro-title {
    font-weight: bold;
    color: #2E2E2E;
    font-size: 1.5em;
  }
  .subtitle {
    font-weight: bold;
    color: #2E2E2E;
    font-size: 1em;
  }
  .has-error {
    border-color: #f86c6b;
  }
  .form-header {
    color: #2E2E2E;
    font-size: 2em;
    font-weight: bold;
  }
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  @import './scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue